export default "__VITE_ASSET__19fd1501__"